import { useTranslation } from "react-i18next";
import { Mainscreen } from "shared/components/Mainscreen/Mainscreen";
import s from "./styles.module.scss";
import { useEffect } from "react";
import Aos from "aos";
import { useMediaQuery } from "@mui/material";
import { breakpoints } from "styles/variables";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import Video from "shared/components/Video/Video";
import { Helmet } from 'react-helmet';

export const ComicHero = () => {
  const isMobile = useMediaQuery(breakpoints.mobile);
  const { t } = useTranslation();

  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <>
      <Helmet
        title="PushKeen – КОМИКС «НАСТОЯЩИЙ ГЕРОЙ»"
        meta={[
          {
            name: "description",
            content:
              "Дополненная реальность помогает посмотреть на комикс «Настоящий герой» под новым углом.",
          },
        ]}
      />
      <section className={s.wr}>
        <Mainscreen
          path={`projects/comicHero/mainscreen${isMobile ? "-mobile" : ""}.jpg`}
        />
        <div className="container">
          <div className={s.about}>
            <div className={s.about_left}>
              <div className={s.about_left_title} data-aos="fade-right">
                <h2 className={s.about_left_title_name}>
                  Комикс «Настоящий герой»
                </h2>
                <span className={s.about_left_title_label}>
                  Дополненная реальность для комикса
                </span>
              </div>
              <div className={s.buttons}>
                <div className={s.game}>2d</div>
              </div>
            </div>

            <div className={s.about_content} data-aos="fade-left">
              <h3 className={s.about_content_name}>О проекте:</h3>
              <span className={s.about_content_label}>
                Дополненная реальность помогает посмотреть на комикс «Настоящий
                герой» под новым углом. Для этого нужно скачать приложение ARka
                и навести камеру смартфона на обложку. Она волшебным образом
                преобразится, создавая для читателя новый уникальный опыт.
              </span>
            </div>
          </div>

          <div className={s.video_wrapper}>
            <LazyLoadComponent>
              <Video
                bgi="projects/comicHero/poster1.jpg"
                videoSrc={"projects/comicHero/video1.mp4"}
              />
            </LazyLoadComponent>
          </div>

          <div className={s.task}>
            <div className={s.task_wrapper} data-aos="fade-right">
              <h3 className={s.point_title}>Мы сделали:</h3>
              <ul className={s.point_text}>
                <li>
                  Разработали анимацию на основе обложки комикса “Настоящий
                  герой” и использовали технологию дополненной реальности, чтобы
                  ее «оживить»
                </li>
              </ul>
            </div>
            <div className={s.task_date} data-aos="fade-left">
              <span className={s.number}>2</span>
              <span className={s.month}>недели</span>
              <span className={s.label}>
                {t("project.list.kdc.steps.date.label")}
              </span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
